import { useEffect, useState } from 'react';
import { apiService } from '../services/apiService';

/**
 * When the backend has {@code auth.test.static-otp.enabled=true}, the UI enables the same
 * captcha bypass and skip-email-OTP behavior in production (no REACT_APP_* build flags required).
 * In development, flows also stay on unless REACT_APP_TEST_STATIC_LOGIN is explicitly {@code false}.
 */
export function useTestAuthFlow(): {
  testAuthFlowEnabled: boolean;
  testStaticCaptcha: string;
  testStaticOtp: string;
} {
  const [serverFlag, setServerFlag] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiService
      .getTestStaticOtpEnabled()
      .then((r) => {
        if (!cancelled) setServerFlag(!!r.testStaticOtpEnabled);
      })
      .catch(() => {
        if (!cancelled) setServerFlag(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const envNotExplicitlyDisabled = process.env.REACT_APP_TEST_STATIC_LOGIN !== 'false';
  const isDev = process.env.NODE_ENV !== 'production';
  const testAuthFlowEnabled =
    serverFlag === true || (serverFlag !== false && isDev && envNotExplicitlyDisabled);

  return {
    testAuthFlowEnabled,
    testStaticCaptcha: process.env.REACT_APP_TEST_STATIC_CAPTCHA || 'TESTR',
    testStaticOtp: process.env.REACT_APP_TEST_STATIC_OTP || '123456',
  };
}
